// Michigan's undergraduate majors (#2596, founder 2026-09-30: "majors offered by
// the college in the public page"). Read on 2026-09-30 from the official List of
// Majors and Degrees on the Office of Undergraduate Admissions site
// (admissions.umich.edu/academics-majors/majors-degrees): every program row with
// the school or college the page names for it, in the page's school order. Michigan
// has no single undergraduate catalog; each school keeps its own bulletin, so this
// list is the one place all 15 schools' majors sit together. It gives no degree
// names, so every degree is null. Sub-majors keep the page's "(Sub-major of ...)"
// wording, and Integrated Business and Engineering appears under both schools, as
// on the page. Flags quote the Requirements and Deadlines page (the college file's
// `requirements` source). Typography is plain ASCII (curly apostrophes become
// straight). The KB's majors list was the starting point; the page wins.
const majors = {
    "slug": "university-of-michigan-ann-arbor",
    "read": "2026-09-30",
    "intro": "Every undergraduate major on Michigan's official Majors and Degrees list, grouped by the school or college that offers it. The list names no degrees, and minors are left out.",
    "groups": [
        {
            "name": "College of Engineering",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Climate and Meteorology",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science (BSE)",
                    "degree": null
                },
                {
                    "name": "Data Science",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Engineering Physics",
                    "degree": null
                },
                {
                    "name": "Environmental Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial and Operations Engineering",
                    "degree": null
                },
                {
                    "name": "Integrated Business and Engineering",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Naval Architecture and Marine Engineering",
                    "degree": null
                },
                {
                    "name": "Nuclear Engineering and Radiological Sciences",
                    "degree": null
                },
                {
                    "name": "Robotics",
                    "degree": null
                },
                {
                    "name": "Space Sciences and Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Literature, Science, and the Arts (LSA)",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Actuarial Mathematics (Sub-major of Mathematics)",
                    "degree": null
                },
                {
                    "name": "Afroamerican and African Studies",
                    "degree": null
                },
                {
                    "name": "American Culture",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Archaeology (Sub-major of Anthropology)",
                    "degree": null
                },
                {
                    "name": "Archaeology of the Ancient Mediterranean",
                    "degree": null
                },
                {
                    "name": "Arts and Ideas in the Humanities (Administered by the Residential College)",
                    "degree": null
                },
                {
                    "name": "Asian Studies",
                    "degree": null
                },
                {
                    "name": "Astronomy and Astrophysics",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Physics (Sub-major of Biophysics)",
                    "degree": null
                },
                {
                    "name": "Biology",
                    "degree": null
                },
                {
                    "name": "Biology, Health, and Society",
                    "degree": null
                },
                {
                    "name": "Biomolecular Science",
                    "degree": null
                },
                {
                    "name": "Biophysics",
                    "degree": null
                },
                {
                    "name": "Biopsychology, Cognition, and Neuroscience",
                    "degree": null
                },
                {
                    "name": "Cellular and Molecular Biomedical Science",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese Studies (Sub-major of Asian Studies)",
                    "degree": null
                },
                {
                    "name": "Classical Civilization",
                    "degree": null
                },
                {
                    "name": "Classical Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Cognitive Science",
                    "degree": null
                },
                {
                    "name": "Communication and Media",
                    "degree": null
                },
                {
                    "name": "Comparative Culture and Identity (Sub-major of International Studies)",
                    "degree": null
                },
                {
                    "name": "Comparative Literature, Arts, and Media",
                    "degree": null
                },
                {
                    "name": "Computer Science (BS)",
                    "degree": null
                },
                {
                    "name": "Creative Writing and Literature (Administered by the Residential College)",
                    "degree": null
                },
                {
                    "name": "Culture and Media (Sub-major of Anthropology)",
                    "degree": null
                },
                {
                    "name": "Data Science (BS)",
                    "degree": null
                },
                {
                    "name": "Drama (Administered by the Residential College)",
                    "degree": null
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": null
                },
                {
                    "name": "Ecology, Evolution, and Biodiversity",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environment",
                    "degree": null
                },
                {
                    "name": "Environment and Conservation (Sub-major of Anthropology)",
                    "degree": null
                },
                {
                    "name": "Ethnic Studies (Sub-major of American Culture)",
                    "degree": null
                },
                {
                    "name": "Film, Television, and Media",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "Gender and Health",
                    "degree": null
                },
                {
                    "name": "General Studies",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "Global Environment and Health (Sub-major of International Studies)",
                    "degree": null
                },
                {
                    "name": "Greek (Ancient) Language and Literature",
                    "degree": null
                },
                {
                    "name": "Greek (Modern) Language and Culture",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History of Art",
                    "degree": null
                },
                {
                    "name": "Honors Mathematics (Sub-major of Mathematics)",
                    "degree": null
                },
                {
                    "name": "Human Origins, Biology, and Behavior",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Astronomy",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Chemical Sciences",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Physics",
                    "degree": null
                },
                {
                    "name": "International Security, Norms, and Cooperation (Sub-major of International Studies)",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Italian",
                    "degree": null
                },
                {
                    "name": "Japanese Studies (Sub-major of Asian Studies)",
                    "degree": null
                },
                {
                    "name": "Judaic Studies",
                    "degree": null
                },
                {
                    "name": "Korean Studies (Sub-major of Asian Studies)",
                    "degree": null
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": null
                },
                {
                    "name": "Latin Language and Literature",
                    "degree": null
                },
                {
                    "name": "Latina/Latino Studies",
                    "degree": null
                },
                {
                    "name": "Law, Justice, and Social Change (Sub-major of Sociology)",
                    "degree": null
                },
                {
                    "name": "Linguistics",
                    "degree": null
                },
                {
                    "name": "Mathematical Sciences (Sub-major of Mathematics)",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Mathematics of Finance and Risk Management (Sub-major of Mathematics)",
                    "degree": null
                },
                {
                    "name": "Medical Anthropology (Sub-major of Anthropology)",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Middle East Studies",
                    "degree": null
                },
                {
                    "name": "Middle Eastern and North African Studies",
                    "degree": null
                },
                {
                    "name": "Molecular, Cellular, and Developmental Biology",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Organizational Studies",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Plant Biology",
                    "degree": null
                },
                {
                    "name": "Polish",
                    "degree": null
                },
                {
                    "name": "Political Economy and Development (Sub-major of International Studies)",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Politics, Law, and Economy (Sub-major of Anthropology)",
                    "degree": null
                },
                {
                    "name": "Power, Identity, and Inequality (Sub-major of Anthropology)",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Pure Mathematics (Sub-major of Mathematics)",
                    "degree": null
                },
                {
                    "name": "Romance Languages and Literatures",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Russian, East European, and Eurasian Studies",
                    "degree": null
                },
                {
                    "name": "Screenwriting (Sub-major of Film, Television, and Media)",
                    "degree": null
                },
                {
                    "name": "Secondary Mathematics Teaching Certificate (Sub-major of Mathematics)",
                    "degree": null
                },
                {
                    "name": "Social Theory and Practice (Administered by the Residential College)",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Sociology and Social Work (Sub-major of Sociology)",
                    "degree": null
                },
                {
                    "name": "Sociology of Health and Medicine (Sub-major of Sociology)",
                    "degree": null
                },
                {
                    "name": "South Asian Studies (Sub-major of Asian Studies)",
                    "degree": null
                },
                {
                    "name": "Southeast Asian Studies (Sub-major of Asian Studies)",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                },
                {
                    "name": "Structural Biology (Sub-major of Biophysics)",
                    "degree": null
                },
                {
                    "name": "Translation",
                    "degree": null
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "Ford School of Public Policy",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Public Policy",
                    "degree": null
                }
            ]
        },
        {
            "name": "Marsal Family School of Education",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Elementary Teacher Education",
                    "degree": null,
                    "flag": "Additional application requirements for the Educator Preparation Program.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Learning, Equity, and Problem Solving for the Public Good (LEAPS)",
                    "degree": null,
                    "flag": "Additional application requirements for LEAPS.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Secondary Teacher Education",
                    "degree": null,
                    "flag": "Additional application requirements for the Educator Preparation Program.",
                    "flagSource": "requirements"
                }
            ]
        },
        {
            "name": "Ross School of Business",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": null,
                    "flag": "An admissions portfolio, submitted with your application to U-M.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Integrated Business and Engineering",
                    "degree": null,
                    "flag": "An admissions portfolio, submitted with your application to U-M.",
                    "flagSource": "requirements"
                }
            ]
        },
        {
            "name": "School of Dentistry",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Information",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Information Analysis and Design",
                    "degree": null
                },
                {
                    "name": "User Experience Design",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Kinesiology",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Applied Exercise Science",
                    "degree": null
                },
                {
                    "name": "Movement Science",
                    "degree": null
                },
                {
                    "name": "Sport Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Music, Theatre & Dance (SMTD)",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Composition",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Dance",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Interarts Performance",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Jazz & Contemporary Improvisation",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music Education",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Music Theory",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Musical Theatre",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Musicology",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Organ",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Performing Arts Technology",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Piano",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Strings",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Theatre & Drama",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Voice & Opera",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Winds & Percussion",
                    "degree": null,
                    "flag": "Additional application requirements, and its own December 1 application deadline.",
                    "flagSource": "requirements"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Community and Global Public Health",
                    "degree": null
                },
                {
                    "name": "Public Health Sciences",
                    "degree": null
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Community Action and Social Change",
                    "degree": null
                }
            ]
        },
        {
            "name": "Stamps School of Art & Design",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Art and Design",
                    "degree": null,
                    "flag": "Additional application requirements, set out on the Stamps site.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Interarts Performance",
                    "degree": null,
                    "flag": "Additional application requirements, set out on the Stamps site.",
                    "flagSource": "requirements"
                }
            ]
        },
        {
            "name": "Taubman College of Architecture & Urban Planning",
            "source": {
                "label": "Michigan Admissions, Majors and Degrees",
                "url": "https://admissions.umich.edu/academics-majors/majors-degrees"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": null,
                    "flag": "Additional application requirements for Architecture majors.",
                    "flagSource": "requirements"
                },
                {
                    "name": "Urban Technology",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
